import React from 'react';
import './Tips.css';

const Tips = () => {

    return (
        <div className="tips-guild">
            <br/>
            <h1>
                <strong>Tips Sử dụng phần mềm H.Work</strong>
            </h1>
            <br/>
            <br/>
            <h2>#Hint 1: Tạo Workspace cho team hoặc dự án.</h2>
            <br/>
            <p>Trong dự án có room (hay topic) là các khối chức năng hoặc dự án.</p>
            <p>
                <strong>*Nên assign thêm quyền admin và mods để người khác đồng hành quản lý.</strong>
            </p>
            <p>
                <strong>*Tạo room có mode public ra ngoài, có mod cho người trong workspace và có cả mod room riêng cho
                    invite person (có thể là trao đổi riêng và hạn chế người trong team tham gia).</strong>
            </p>
            <br/>
            <br/>
            <h2>#Hint 2: Cách để gửi tin nhắn kèm hiệu ứng trên H.Work.</h2>
            <br/>
            <p><text className="syntax">Cú pháp: </text>  <strong> /&lt;hiệu_ứng&gt; &lt;nội_dung_tin nhắn&gt;</strong>
            </p>
            <br/>
            <p>Danh sách một số hiệu ứng phổ biến: </p>
            <ul>
                <li>
                    <strong>/confetti</strong> &lt;message&gt;: Hiệu ứng hoa giấy
                </li>
                <li>
                    <strong>/fireworks</strong> &lt;message&gt;: Hiệu ứng pháo hoa
                </li>
                <li>
                    <strong>/rainfall</strong> &lt;message&gt;: Hiệu ứng kiểu mưa rơi
                </li>
                <li>
                    <strong>/snowfall</strong> &lt;message&gt;: Hiệu ứng tuyết rơi
                </li>
                <li>
                    <strong>/spaceinvaders</strong> &lt;message&gt;: Hiệu ứng chủ đề space
                </li>
                <li>
                    <strong>/hearts</strong> &lt;message&gt;: Hiệu ứng trái tim
                </li>
            </ul>
            <br/>
            <br/>
            <h2>#Hint 3: Thay đổi nickname cho bạn:</h2>
            <br/>
            <p>
                <strong>Cách 1: Thay đổi nickname cho phòng nhắn tin hiện tại.</strong>
            </p>
            <p><text className="syntax">Cú pháp: </text><strong>/myroomnick</strong> &lt;nick_name&gt; : Apply với phòng chat hiện tại, các phòng chat khác không thay
                đổi.</p>
            <br/>
            <p>
                <strong>Cách 2: Thay đổi nickname của bạn</strong>.
            </p>
            <p><text className="syntax">Cú pháp: </text><strong>/nickname</strong> &lt;nick_name&gt;: Apply với toàn bộ các room, Space.</p>
            <br/>
            <br/>
            <h2>#Hint 4 Quan Trọng:</h2>
            <br/>
            <p>
                <strong>Tips sử dụng H.Work:</strong>
            </p>
            <p>Ít nhất 1 phiên làm việc phải luôn luôn được mở ( tốt nhất là trên điện thoại ). Điều này sẽ giúp anh chị
                luôn nhận được key giải mã tin nhắn trong trường hợp các thiết bị khác gặp sự cố kết nối.</p>

        </div>
    );
};

export default Tips;